export class UBXCarousel {

}
